var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _circle, _ellipse, _ellipse2, _g3, _ellipse3, _g4, _path12, _path13, _path14, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.103a8.828 8.828 0 0 1 8.828-8.827z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M0 200.09h512V311.9H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M173.021 200.07h-63.559l-2.648-15.89h68.855z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd350",
    d: "M108.8 196.097l.662 3.973h63.559l.662-3.973z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.92 147.1h2.648v10.593h-2.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.27 149.75h7.945v2.648h-7.945zM173.228 189.476a2.648 2.648 0 0 1-2.49-3.551l5.61-15.481a2.807 2.807 0 0 0-.18-2.319c-.209-.375-.695-1.035-1.624-1.234-6.839-1.453-20.096-3.897-32.023-3.897h-2.558c-11.927 0-25.184 2.444-32.026 3.9-.926.196-1.414.856-1.622 1.231a2.803 2.803 0 0 0-.179 2.319l5.608 15.481a2.648 2.648 0 0 1-1.587 3.393 2.656 2.656 0 0 1-3.392-1.588l-5.61-15.481a8.104 8.104 0 0 1 .526-6.694c1.097-1.978 2.973-3.38 5.149-3.843 7.047-1.5 20.718-4.017 33.131-4.017h2.558c12.413 0 26.084 2.516 33.128 4.013a7.757 7.757 0 0 1 5.152 3.846 8.107 8.107 0 0 1 .527 6.694l-5.611 15.481a2.642 2.642 0 0 1-2.487 1.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.251 187.159a2.647 2.647 0 0 1-2.648-2.648v-21.517a2.647 2.647 0 1 1 5.296 0v21.517a2.647 2.647 0 0 1-2.648 2.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.559 189.476a2.649 2.649 0 0 1-2.596-3.186l3.212-15.481c.418-2.017-.236-3.784-.608-4.094-3.672-1.347-11.039-3.722-17.594-3.722h-1.465c-6.554 0-13.921 2.375-17.73 3.791-.235.241-.889 2.007-.472 4.024l3.212 15.481a2.648 2.648 0 0 1-2.055 3.132c-1.434.277-2.836-.623-3.13-2.056l-3.212-15.481c-.8-3.859.428-8.801 3.808-10.063 5.063-1.882 12.565-4.125 19.578-4.125h1.465c7.014 0 14.516 2.242 19.576 4.122 3.383 1.265 4.611 6.207 3.811 10.066l-3.212 15.481a2.644 2.644 0 0 1-2.588 2.111z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd350",
    d: "M107.476 188.152h67.531l.662-3.972h-68.855z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.924 200.07a2.649 2.649 0 0 0-2.648 2.648v92.486c0 29.365 23.713 53.17 52.966 53.17s52.966-23.805 52.966-53.17v-92.486a2.649 2.649 0 0 0-2.648-2.648H90.924z",
    fill: "#ff4b55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.538 287.464l5.297-13.241-10.593 2.648-10.593-2.648 5.297 13.241-13.241 45.021s7.945 5.297 18.538 5.297 18.538-5.297 18.538-5.297l-13.243-45.021z",
    fill: "#f5f5f5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M122.061 298.135l-4.673 1.169 10.279-18.501-4.63-2.571-12.485 22.472H98.869v5.297h5.69l-7.344 5.875 3.308 4.138 6.239-4.992-2.461 7.382 5.025 1.675 4.837-14.511 9.183-2.296z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.703 226.552l-12.089-6.045a5.297 5.297 0 0 1-2.77-6.022l.684-2.735a3.007 3.007 0 0 0-5.266-2.607 44.22 44.22 0 0 0-9.69 27.625v55.991s11.059-2.211 21.048-16.742c1.834-2.668 4.853-4.247 8.072-4.412l-5.286 15.857L128 290.111l9.269-11.03-14.566-52.529z",
    fill: "#f5f5f5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M160.422 298.135l4.673 1.169-10.279-18.501 4.63-2.571 12.484 22.472h11.684v5.297h-5.691l7.345 5.875-3.308 4.138-6.239-4.992 2.461 7.382-5.026 1.675-4.836-14.511-9.183-2.296z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.779 226.552l12.089-6.045a5.297 5.297 0 0 0 2.77-6.022l-.684-2.735a3.007 3.007 0 0 1 5.266-2.607 44.22 44.22 0 0 1 9.69 27.625v55.991s-11.059-2.211-21.048-16.742c-1.834-2.668-4.853-4.247-8.072-4.412l5.286 15.857-10.593 2.648-9.269-11.03 14.565-52.528z",
    fill: "#f5f5f5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.352 208.014H112.11l3.973 5.297 9.269 2.648-5.297 2.648H128zM157.131 208.014h13.241l-3.972 5.297-9.269 2.648 5.297 2.648h-7.945z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158.996 205.938l-12.458 2.076-5.297 10.593-5.297-10.593-12.458-2.076c-1.428-.238-2.524 1.245-1.876 2.54l6.39 12.778-5.297 5.297h37.076l-5.297-5.297 6.389-12.778c.648-1.296-.447-2.779-1.875-2.54z",
    fill: "#f5f5f5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.24,
    cy: 185.34,
    r: 3.972,
    fill: "#ffbe50"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.19,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    fill: "#41479b"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.52,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    fill: "#ff4b55"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.85,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.52,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.85,
    cy: 194.82,
    rx: 3.139,
    ry: 2.207,
    fill: "#ff4b55"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbe50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.65,
    cy: 185.34,
    r: 3.972
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.17,
    cy: 185.34,
    r: 3.972
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.86,
    cy: 185.34,
    r: 3.972
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.33,
    cy: 185.34,
    r: 3.972
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.803 162.994a5.239 5.239 0 0 0 .735-2.648 5.297 5.297 0 1 0-10.594 0c0 .97.279 1.867.735 2.648h9.124z",
    fill: "#41479b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.241 280.842c-10.953 0-19.862-8.909-19.862-19.862v-35.752h39.724v35.752c0 10.954-8.909 19.862-19.862 19.862z",
    fill: "#ff4b55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.779 226.552v34.428c0 10.238-8.3 18.538-18.538 18.538s-18.538-8.3-18.538-18.538v-34.428h37.076m2.649-2.648H120.056v37.076c0 11.682 9.504 21.186 21.186 21.186s21.186-9.504 21.186-21.186v-37.076z",
    fill: "#a54b50"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.269 279.08c1.281.28 2.607.437 3.972.437s2.691-.158 3.972-.437v-52.529h-7.945l.001 52.529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7 248.4h37.08v7.945H122.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/rs.f8d8a8b2a930619e2b824aff803c253e.svg";
export { ForwardRef as ReactComponent };